import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from '../../../flux/Flux';

class TeaserProvider extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            teasers: Flux.Teaser.getTeasers(),
        };

        this.onTeasersChange = this.onTeasersChange.bind(this);
    }

    componentDidMount() {
        Flux.Teaser.addTeasersChangeListener(this.onTeasersChange);

        // only load if teasers are not already cached
        if (this.state.teasers === null) {
            Flux.Teaser.loadTeasers(Flux.VXMobile.getRouteName(), Flux.VXMobile.getRouteArgs());
        }
    }

    componentWillUnmount() {
        Flux.Teaser.removeTeasersChangeListener(this.onTeasersChange);
    }

    onTeasersChange() {
        this.setState({
            teasers: Flux.Teaser.getTeasers(),
        });
    }

    getTeasers() {
        return (this.state.teasers && this.state.teasers[this.props.context]) || [];
    }

    render() {
        const {as: Tag, children, context, render} = this.props;

        if (typeof render === 'function') {
            return render({teasers: this.getTeasers(), context: context});
        } else {
            const content = React.Children.map(children,
                    (child) => React.cloneElement(child, {
                        initialTeasers: this.getTeasers(),
                        context:        context,
                    })
            );
            return <Tag>{content}</Tag>;
        }
    }
}

TeaserProvider.propTypes = {
    as:       PropTypes.string,
    children: PropTypes.node,
    context:  PropTypes.string,
    render:   PropTypes.func,
};

TeaserProvider.defaultProps = {
    as:      'div',
    context: 'default',
};

export default TeaserProvider;
